import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { AdminLayout } from '@/admin-design/_common'
import { LayoutDashboard, Package, FlaskConical, ShoppingCart, Truck, Briefcase, Settings, Tag, Calculator, ImageIcon } from 'lucide-react'
import { api } from '../api/client'

interface Props {
  children: ReactNode
}

const navItems = [
  { to: '/', label: 'Dashboard', end: true, icon: <LayoutDashboard size={14} aria-hidden="true" /> },
  { to: '/products', label: 'Products', icon: <Package size={14} aria-hidden="true" /> },
  { to: '/income', label: 'Income', icon: <ShoppingCart size={14} aria-hidden="true" /> },
  { to: '/analyze', label: 'Analyze', icon: <FlaskConical size={14} aria-hidden="true" /> },
  { to: '/orders', label: 'Orders', icon: <Truck size={14} aria-hidden="true" /> },
  { to: '/jobs', label: 'Jobs', icon: <Briefcase size={14} aria-hidden="true" /> },
  { to: '/reprice', label: 'Reprice', icon: <Tag size={14} aria-hidden="true" /> },
  { to: '/bulk-adjust', label: 'Bulk Adjust', icon: <Calculator size={14} aria-hidden="true" /> },
  { to: '/composites', label: 'Composites', icon: <ImageIcon size={14} aria-hidden="true" /> },
  { to: '/settings', label: 'Settings', icon: <Settings size={14} aria-hidden="true" /> },
]

export default function Layout({ children }: Props) {
  const navigate = useNavigate()
  const qc = useQueryClient()

  const logout = async () => {
    await api.logout()
    qc.setQueryData(['me'], null)
    navigate('/login')
  }

  return (
    <AdminLayout
      brand="Shopping Sync"
      navItems={navItems}
      onLogout={logout}
    >
      {children}
    </AdminLayout>
  )
}
